import React from "react";
import { Form, Input, Select } from "antd";
const { Option, OptGroup } = Select;
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  preUrl,
  onChange,
  onSearch,
  technicalSkills
}) {
  return (
    <Form {...formItemLayout}>
      <Form.Item label="Website" className="formsteponeinout">
        {getFieldDecorator("cpWebsiteName", {
          rules: [
            {
              required: true,
              message: "Please select webiste"
            },
            {
              validator: (rule, value, callback) => {
                var c = [];
                Object.keys(technicalSkills).forEach(i => {
                  c.push(i);
                });

                if (c.includes(value) && value !== "Other") {
                  callback(
                    "You have already added " +
                      value +
                      "  to your profile. Delete it first if you would like to add as new one"
                  );
                } else {
                  callback();
                }
              }
            }
          ]
        })(
          <Select
            showSearch
            style={{
              width: 200
            }}
            placeholder="Select Website"
            optionFilterProp="children"
            onChange={onChange}
            onSearch={() => {
              //  =>  {
              // if (typeof option.props.label === "undefined") {
              //   return (
              //     option.props.children
              //       .toLowerCase()
              //       .indexOf(input.toLowerCase()) >= 0
              //   );
              // } else {
              //   return false;
              // }
            }}
          >
            <OptGroup label="Competitve Programming">
              <Option value="HackerEarth">HackerEarth</Option>
              <Option value="HackerRank">HackerRank</Option>
              <Option value="GeeksForGeeks">GeeksForGeeks</Option>
              <Option value="CodeChef">CodeChef</Option>
              <Option value="InterviewBit">InterviewBit</Option>
              <Option value="CodeForces">CodeForces</Option>
              <Option value="Spoj">Spoj</Option>
              <Option value="TopCoder">TopCoder</Option>
            </OptGroup>
            <OptGroup label="Developer Profile">
              <Option value="Github">Github</Option>
              <Option value="StackOverFlow">StackOverFlow</Option>
            </OptGroup>
          </Select>
        )}
      </Form.Item>
      <Form.Item label="Enter your Username" className="formsteponeinout">
        {getFieldDecorator("cpWebsiteUserName", {
          rules: [
            {
              required: true,
              message: "Please enter your username"
            }
          ]
        })(
          <Input placeholder="Keep only your username" addonBefore={preUrl} />
        )}
      </Form.Item>
      <p>
        You may get your username by logging into respective website and click
        on profile
      </p>
    </Form>
  );
}
